import { render } from "./index.vue?vue&type=template&id=08d6652a"
import script from "./multi-item-selector.ts?vue&type=script&lang=js"
export * from "./multi-item-selector.ts?vue&type=script&lang=js"

import "./multi-item-selector.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script